import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Regiment } from '../models/regiment';
import { State } from '../models/state';
import { BranchOfService } from '../models/branchOfService';
import { WriteOrdinalSuffixOfNumber, NumericSortArrayByProperty } from 'starbase-launcher';
import { StarbaseNotificationService, StarbaseNotificationTypes } from 'starbase-notification';
import { AppInsightsService } from '../app-insights.service';
import { UnitArmies } from '../models/unitLinking';
import { LookupDataService } from '../services/lookup-data.service';
import { BreakpointService, BreakpointState } from '../breakpoint.service';
// import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-unit-picker',
  templateUrl: './unit-picker.component.html',
  styleUrls: ['./unit-picker.component.css'],
  // providers: [{
  //   provide: BsDropdownConfig,
  //   useValue: {
  //     isAnimated: true,
  //     autoClose: true
  //   }
  // }]
})
export class UnitPickerComponent implements OnInit {
  @Input() regiments: Regiment[];
  @Input() states: State[];
  @Input() branches: BranchOfService[];
  @Input() coLetters: string[];
  @Input() resetAfterAdd = false; // determines whether the dropdowns will all be reset to Any after pressing 'Add' button.
  @Input() showHeaders = true;
  @Input() singleUnitMode = false;

  @Output() unitSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('armyDropdown', { static: true }) firstField: ElementRef;

  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  public unitArmyChosen: UnitArmies = 0;
  public regimentChosen: Regiment = null;
  public stateChosen: State = null;
  public branchChosen: BranchOfService = null;
  public coLettersChosen: string[] = [];
  public corpsChosen: number = null;

  ordinalSuffix = WriteOrdinalSuffixOfNumber;
  unitArmies = Object.keys(UnitArmies);

  private _subscription;
  isHandset: boolean = false;

  corps: number[] = []; // corps data
  ua = UnitArmies; // armies data

  constructor(private notiSvc: StarbaseNotificationService,
    private appInsightsSvc: AppInsightsService,
    private lookupSvc: LookupDataService,
    private breakpointService: BreakpointService) {
    this.unitArmies = this.unitArmies.slice(this.unitArmies.length / 2, this.unitArmies.length);
   }

  ngOnInit() {

    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
     )

    this.lookupSvc.getAllCorps().subscribe(n => this.corps.push(n));
    if (this.regiments.length < 1 || this.states.length < 1 || this.branches.length < 1 || this.corps.length < 1) {
      const errPhrase = 'Unit Picker did not receive all required data and will not function correctly.';
      this.appInsightsSvc.logError(new Error(errPhrase));
      console.error(errPhrase);
    }
    this.regiments = NumericSortArrayByProperty(this.regiments, 'regimentNo');
    this.firstField.nativeElement.focus();
  }

  /* eslint-disable eqeqeq */
  unitArmyChoice(val: number | undefined) {
    this.unitArmyChosen = val;
    if (this.singleUnitMode) {
      this.done();
    }
  }
  corpsChoice(val: number) {
    if (val == 0) {
      this.corpsChosen = null;
      return;
    }
    this.corpsChosen = val;
    if (this.singleUnitMode) {
      this.done();
    }
  }
  regimentChoice(val: Regiment) {
    if (val == null) {
      this.regimentChosen = null;
      return;
    }
    this.regimentChosen = val;
    if (this.singleUnitMode) {
      this.done();
    }
  }
  stateChoice(val: State) {
    if (val == null) {
      this.stateChosen = null;
      return;
    }
    this.stateChosen = val;
    if (this.singleUnitMode) {
      this.done();
    }
  }
  branchChoice(val: BranchOfService) {
    if (val == null) {
      this.branchChosen = null;
      return;
    }
    this.branchChosen = val;
    if (this.singleUnitMode) {
      this.done();
    }
  }
  coLetterChoice(val: string) {
    if (val == null) {
      this.coLettersChosen = [];
      return;
    }
    if (this.coLetterChoice.length >= 78) {
      return;
    }
    this.coLettersChosen.push(val);
    if (this.singleUnitMode) {
      this.done();
    }
  }

  findDuplicateCompanyLetters(letters: string[]) {
    const r = [...new Set<string>(letters)];
    r.forEach(a => a.toUpperCase());
    return r;
  }

  handleCoLetterKeypress(event) {
    const charCode = String.fromCharCode(event.which).toUpperCase();
    this.handleKeypressCommands(event);
    this.coLetters.forEach(l => {
      if (l === charCode) {
        this.coLetterChoice(l);
      }
    });
  }
  handleKeypressCommands(event) {
    if (event.keyCode === 13) { // enter key
      event.preventDefault();
      this.done();
    } else if (event.keyCode == 27) { // esc key
      event.preventDefault();
      this.reset();
    }
  }

  public reset() {
    this.unitArmyChoice(undefined);
    this.branchChoice(null);
    this.stateChoice(null);
    this.regimentChoice(null);
    this.coLetterChoice(null);
    this.corpsChoice(null);
    console.log('Unit Picker choices reset.');
    this.firstField.nativeElement.focus();
  }
  public done() {
    if (this.regimentChosen === null
      && this.stateChosen === null
      && this.branchChosen === null
      && this.unitArmyChosen < 1
      && this.corpsChosen === null
      && this.coLettersChosen.length == 0) {
        if (!this.singleUnitMode) {
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Invalid Unit Specified',
              'Please specify at least one unit field.',
              StarbaseNotificationTypes.Warning, 3000));
          return false;
        } else {
          this.unitSelected.emit(null);
        }
      }
    this.unitSelected.emit(this.getSelected());
    if (this.resetAfterAdd) {
      this.reset();
    }
  }
  public setSelectedUnitArmy(army: UnitArmies): void {
    this.unitArmyChosen = army;
  }
  public setSelectedCorps(corps: number): void {
    this.corpsChosen = corps;
  }
  public setSelectedRegiment(regiment: Regiment): void {
    this.regimentChosen = regiment;
  }
  public setSelectedState(state: State): void {
    this.stateChosen = state;
  }
  public setSelectedBranch(branch: BranchOfService): void {
    this.branchChosen = branch;
  }
  public setSelectedCoLetters(coLetters: string[]): void {
    coLetters.forEach(l => this.coLetterChoice(l));
  }
  private getSelected(): {
    army: UnitArmies;
    corps: number;
    regiment: Regiment;
    state: State;
    branch: BranchOfService;
    coLetters: string[];
  } {
    return {
      army: this.unitArmyChosen,
      corps: this.corpsChosen,
      regiment: this.regimentChosen,
      state: this.stateChosen,
      branch: this.branchChosen,
      coLetters: (this.coLettersChosen.length > 0)
        ? this.findDuplicateCompanyLetters(this.coLettersChosen) : ['']
    };
  }

}
